import {
  Accordion,
  Header,
  HeaderArt,
  HeaderSub,
  HeaderTitle,
  List,
  Num,
  SecHead,
  Section,
  Wrap,
} from './guideUi';

/** 예약변경 및 취소 규정 — 네이티브 인포그래픽. */
const CancellationGuide = () => {
  return (
    <Wrap>
      <Header>
        <HeaderArt aria-hidden>
          <svg viewBox='0 0 48 48' fill='none'>
            <rect
              x='8'
              y='12'
              width='32'
              height='28'
              rx='4'
              fill='rgba(255,255,255,0.16)'
              stroke='#fff'
              strokeWidth='2'
            />
            <path
              d='M8 20h32M16 8v8M32 8v8'
              stroke='#fff'
              strokeWidth='2'
              strokeLinecap='round'
            />
            <path
              d='M20 28l8 8M28 28l-8 8'
              stroke='#fff'
              strokeWidth='2'
              strokeLinecap='round'
            />
          </svg>
        </HeaderArt>
        <HeaderTitle>예약변경 및 취소 규정</HeaderTitle>
        <HeaderSub>변경·취소 방법과 환불 기준을 확인하세요.</HeaderSub>
      </Header>

      <Section>
        <SecHead>
          <Num>1</Num> 예약변경 및 취소 방법
        </SecHead>
        <List>
          <li>
            예약 변경은 취소와 동일하게 취급되며 예약현황에 따라 불가할 수
            있습니다. 변경은 예약실로 전화 주세요.
          </li>
          <li>예약 취소는 예약조회 페이지에서 바로 처리 가능합니다.</li>
          <li>예약변경은 최소 1일 전에 연락 주시기 바랍니다.</li>
          <li>
            고객 사정으로 인수시간이 늦어진 경우 환불 불가, 반납시간 연장도
            불가합니다(연장은 예약실 문의·요금 별도).
          </li>
          <li>조기 반납 시 해당 시간에 대한 환불금은 없습니다.</li>
        </List>
      </Section>

      <Section>
        <SecHead>
          <Num>2</Num> 예약금 환불
        </SecHead>
        <List>
          <li>
            사전통보 없이 대여 예정시간을 1시간 이상 경과하면 예약은 취소된
            것으로 보며 예약금은 반환하지 않습니다.
          </li>
          <li>고객 사정으로 취소 시 취소규정에 따라 수수료가 부과됩니다.</li>
          <li>대여예정시간 24시간 이내 취소 시 예약금은 반환하지 않습니다.</li>
          <li>
            천재지변 등 불가항력으로 계약을 체결할 수 없게 된 경우 예약금을
            반환합니다.
          </li>
        </List>
      </Section>

      <Accordion num={3} title='차종변경 수수료'>
        <List>
          <li>경차 / 소형 : 20,000원</li>
          <li>준중형 / 중형 : 30,000원</li>
          <li>고급 / SUV : 40,000원</li>
          <li>수입 / 승합 : 50,000원</li>
          <li>슈퍼카 : 변경 불가 (24시간 금액 청구)</li>
          <li>
            ※ 수수료(초기 예약 차종 기준)와 별도로 렌트 요금 차액이 추가
            청구됩니다.
          </li>
        </List>
      </Accordion>
    </Wrap>
  );
};

export default CancellationGuide;
